// extracted by mini-css-extract-plugin
module.exports = {"value":"styles_value__y9YZB","text":"styles_text__r5d_O","skeleton-animation":"styles_skeleton-animation__MRbJv"};